import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export default function DrugIdMissing(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        version="1.1"
        id="svg7497"
        viewBox="0 0 682.66669 682.66669"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="matrix(1,0,0,1,0,0)">
          <defs id="defs7501">
            <clipPath clipPathUnits="userSpaceOnUse" id="clipPath7511">
              <path
                d="M 0,512 H 512 V 0 H 0 Z"
                id="path7509"
                fill="#000000"
                fill-opacity="1"
                data-original-color="#000000ff"
                stroke="none"
                stroke-opacity="1"
              />
            </clipPath>
          </defs>
          <g
            id="g7503"
            transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
          >
            <g id="g7505">
              <g id="g7507" clip-path="url(#clipPath7511)">
                <g id="g7513" transform="translate(26.1553,26.1553)">
                  <path
                    d="M 0,0 V 0 C -26.677,26.677 -24.448,70.566 4.795,94.403 L 208.803,260.699 260.699,208.803 94.403,4.795 C 70.566,-24.448 26.677,-26.677 0,0"
                    id="path7515"
                    fill="#ffffff"
                    fill-opacity="1"
                    data-original-color="#d48c64ff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7517" transform="translate(265.1191,256.6943)">
                  <path
                    d="m 0,0 -159.561,-195.744 c -23.836,-29.243 -67.726,-31.472 -94.403,-4.795 -0.837,0.836 -1.643,1.689 -2.423,2.559 2.36,-11.891 8.133,-23.269 17.423,-32.559 26.677,-26.677 70.567,-24.448 94.403,4.795 L 21.736,-21.736 Z"
                    id="path7519"
                    fill="#cdcdcd"
                    fill-opacity="1"
                    data-original-color="#c6805dff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7521" transform="translate(446.1279,164.2803)">
                  <path
                    d="m 0,0 c -77.83,-77.829 -204.018,-77.829 -281.848,0 -77.829,77.83 -77.829,204.018 0,281.848 77.83,77.829 204.018,77.829 281.848,0 C 77.829,204.018 77.829,77.83 0,0"
                    id="path7523"
                    fill="#ffffff"
                    fill-opacity="1"
                    data-original-color="#80b4fbff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7525" transform="translate(446.127,446.1279)">
                  <path
                    d="M 0,0 C -42.732,42.732 -100.043,61.996 -155.923,57.804 -110.027,54.36 -65.096,35.097 -30,0 c 77.83,-77.83 77.83,-204.018 0,-281.847 -35.096,-35.097 -80.027,-54.361 -125.923,-57.804 55.88,-4.192 113.191,15.071 155.923,57.804 C 77.83,-204.018 77.83,-77.83 0,0"
                    id="path7527"
                    fill="#d2d2d2"
                    fill-opacity="1"
                    data-original-color="#61a2f9ff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7529" transform="translate(164.2803,305.2041)">
                  <path
                    d="M 0,0 C 0,77.706 63.218,140.924 140.924,140.924 218.63,140.924 281.848,77.706 281.848,0 281.848,-77.706 218.63,-140.924 140.924,-140.924 63.218,-140.924 0,-77.706 0,0"
                    id="path7531"
                    fill="#f9f7f8"
                    fill-opacity="1"
                    data-original-color="#f9f7f8ff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7533" transform="translate(305.2041,446.1279)">
                  <path
                    d="m 0,0 c -5.066,0 -10.069,-0.275 -15,-0.8 70.68,-7.512 125.923,-67.484 125.923,-140.124 0,-72.639 -55.243,-132.611 -125.923,-140.124 4.931,-0.524 9.934,-0.799 15,-0.799 77.706,0 140.923,63.217 140.923,140.923 C 140.923,-63.218 77.706,0 0,0"
                    id="path7535"
                    fill="#efedef"
                    fill-opacity="1"
                    data-original-color="#efedefff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7537" transform="translate(252.1201,358.2881)">
                  <path
                    d="M 0,0 V 0 C 11.688,11.687 30.636,11.687 42.322,0 L 74.256,-31.935 31.935,-74.256 0,-42.322 C -11.687,-30.635 -11.687,-11.687 0,0"
                    id="path7539"
                    fill="#ff8fa1"
                    fill-opacity="1"
                    data-original-color="#ff5f7aff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7541" transform="translate(294.4424,358.2881)">
                  <path
                    d="m 0,0 c -11.687,11.687 -30.636,11.687 -42.322,0 -2.642,-2.642 -4.68,-5.656 -6.128,-8.872 11.012,4.956 24.404,2.917 33.45,-6.128 l 31.935,-31.935 15,15 z"
                    id="path7543"
                    fill="#fb4455"
                    fill-opacity="1"
                    data-original-color="#fb4455ff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7545" transform="translate(326.376,326.3535)">
                  <path
                    d="m 0,0 -42.321,-42.321 31.856,-31.858 c 11.73,-11.729 30.713,-11.763 42.4,-0.077 11.686,11.688 11.652,30.67 -0.078,42.4 z"
                    id="path7547"
                    fill="#b4b4b2"
                    fill-opacity="1"
                    data-original-color="#ffe077ff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7549" transform="translate(358.2334,294.4971)">
                  <path
                    d="m 0,0 -31.856,31.856 -15,-15 L -30,0 c 11.729,-11.729 11.765,-30.712 0.077,-42.399 -1.879,-1.879 -3.947,-3.45 -6.142,-4.723 11.472,-6.623 26.361,-5.059 36.142,4.723 C 11.765,-30.712 11.729,-11.729 0,0"
                    id="path7551"
                    fill="#868583"
                    fill-opacity="1"
                    data-original-color="#ffd05bff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7553" transform="translate(208.9434,403.7783)">
                  <path
                    d="m 0,0 c 0,-47.343 -38.379,-85.722 -85.722,-85.722 -47.342,0 -85.721,38.379 -85.721,85.722 0,47.343 38.379,85.722 85.721,85.722 C -38.379,85.722 0,47.343 0,0"
                    id="path7555"
                    fill="#ff8fa1"
                    fill-opacity="1"
                    data-original-color="#ff5f7aff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7557" transform="translate(123.2217,489.5)">
                  <path
                    d="m 0,0 c -5.12,0 -10.127,-0.475 -15,-1.335 40.187,-7.097 70.722,-42.164 70.722,-84.387 0,-42.222 -30.535,-77.29 -70.722,-84.385 4.873,-0.862 9.88,-1.336 15,-1.336 47.343,0 85.722,38.379 85.722,85.721 C 85.722,-38.379 47.343,0 0,0"
                    id="path7559"
                    fill="#fb4455"
                    fill-opacity="1"
                    data-original-color="#fb4455ff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7561" transform="translate(86.1084,51.0557)">
                  <path
                    d="m 0,0 c 9.679,9.68 9.679,25.373 0,35.053 -9.68,9.678 -25.374,9.678 -35.053,0 C -44.732,25.373 -44.732,9.68 -35.053,0 -25.374,-9.68 -9.68,-9.68 0,0"
                    id="path7563"
                    fill="#ffffff"
                    fill-opacity="1"
                    data-original-color="#ffffffff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7565" transform="translate(204.0801,133.4199)">
                  <path
                    d="m 0,0 -83.52,-102.47 c -23.84,-29.24 -67.73,-31.469 -94.4,-4.79 -26.68,26.67 -24.45,70.56 4.79,94.401 L -70.66,70.66 C -62.29,56.45 -52,43.061 -39.8,30.86 -27.6,18.66 -14.21,8.37 0,0 Z"
                    id="path7567"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7569" transform="translate(316.4189,504.1865)">
                  <path
                    d="M 0,0 C -46.286,2.593 -93.303,-10.88 -131.979,-40.417"
                    id="path7571"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7573" transform="translate(106.4297,319.71)">
                  <path
                    d="m 0,0 c -2.88,-39.76 6.11,-80.229 26.99,-115.63 8.37,-14.21 18.66,-27.599 30.861,-39.8 12.2,-12.2 25.589,-22.49 39.799,-30.86 76.411,-45.06 176.42,-34.77 242.05,30.86 77.83,77.83 77.83,204.02 0,281.85 -27.148,27.148 -60.18,44.826 -94.993,53.035"
                    id="path7575"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7577" transform="translate(305.2002,164.2803)">
                  <path
                    d="M 0,0 C -4.133,0 -8.225,0.179 -12.268,0.529 -84.246,6.766 -140.92,67.353 -140.92,140.92 c 0,8.359 0.73,16.559 2.13,24.53"
                    id="path7579"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7581" transform="translate(208.8398,407.9404)">
                  <path
                    d="m 0,0 c 25.22,23.67 59.13,38.189 96.36,38.189 77.71,0 140.93,-63.219 140.93,-140.929 0,-65.662 -45.148,-120.985 -106.037,-136.549"
                    id="path7583"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7585" transform="translate(252.1201,358.2881)">
                  <path
                    d="M 0,0 V 0 C 11.688,11.687 30.636,11.687 42.322,0 L 74.256,-31.935 31.935,-74.256 0,-42.322 C -11.687,-30.635 -11.687,-11.687 0,0 Z"
                    id="path7587"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7589" transform="translate(326.376,326.3535)">
                  <path
                    d="m 0,0 -42.321,-42.321 31.856,-31.858 c 11.73,-11.729 30.713,-11.763 42.4,-0.077 11.686,11.688 11.652,30.67 -0.078,42.4 z"
                    id="path7591"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7593" transform="translate(208.9434,403.7783)">
                  <path
                    d="m 0,0 c 0,-47.343 -38.379,-85.722 -85.722,-85.722 -47.342,0 -85.721,38.379 -85.721,85.722 0,47.343 38.379,85.722 85.721,85.722 C -38.379,85.722 0,47.343 0,0 Z"
                    id="path7595"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7597" transform="translate(120.7383,358.4492)">
                  <path
                    d="M 0,0 C 0,-4.142 3.358,-7.5 7.5,-7.5 11.643,-7.5 15,-4.142 15,0 15,4.143 11.643,7.5 7.5,7.5 3.358,7.5 0,4.143 0,0"
                    id="path7599"
                    fill="#000000"
                    fill-opacity="1"
                    data-original-color="#000000ff"
                    stroke="none"
                    stroke-opacity="1"
                  />
                </g>
                <g id="g7601" transform="translate(105.2627,427.2119)">
                  <path
                    d="M 0,0 C 0,1.088 0.075,2.157 0.222,3.205 1.802,14.529 11.636,23.21 23.45,22.972 35.401,22.73 45.301,13.159 45.921,1.223 c 0.686,-13.229 -9.851,-24.2 -22.945,-24.2 v -24.025"
                    id="path7603"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7605" transform="translate(86.1084,51.0557)">
                  <path
                    d="m 0,0 c 9.679,9.68 9.679,25.373 0,35.053 -9.68,9.678 -25.374,9.678 -35.053,0 C -44.732,25.373 -44.732,9.68 -35.053,0 -25.374,-9.68 -9.68,-9.68 0,0 Z"
                    id="path7607"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="1"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
      {/* <svg
        version="1.1"
        id="svg7497"
        viewBox="0 0 682.66669 682.66669"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="matrix(1,0,0,1,0,0)">
          <defs id="defs7501">
            <clipPath clipPathUnits="userSpaceOnUse" id="clipPath7511">
              <path
                d="M 0,512 H 512 V 0 H 0 Z"
                id="path7509"
                fill="#000000"
                fill-opacity="1"
                data-original-color="#000000ff"
                stroke="none"
                stroke-opacity="2"
              />
            </clipPath>
          </defs>
          <g
            id="g7503"
            transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
          >
            <g id="g7505">
              <g id="g7507" clip-path="url(#clipPath7511)">
                <g id="g7513" transform="translate(26.1553,26.1553)">
                  <path
                    d="M 0,0 V 0 C -26.677,26.677 -24.448,70.566 4.795,94.403 L 208.803,260.699 260.699,208.803 94.403,4.795 C 70.566,-24.448 26.677,-26.677 0,0"
                    id="path7515"
                    fill="#c6c6c6"
                    fill-opacity="1"
                    data-original-color="#d48c64ff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7517" transform="translate(265.1191,256.6943)">
                  <path
                    d="m 0,0 -159.561,-195.744 c -23.836,-29.243 -67.726,-31.472 -94.403,-4.795 -0.837,0.836 -1.643,1.689 -2.423,2.559 2.36,-11.891 8.133,-23.269 17.423,-32.559 26.677,-26.677 70.567,-24.448 94.403,4.795 L 21.736,-21.736 Z"
                    id="path7519"
                    fill="#8b8a89"
                    fill-opacity="1"
                    data-original-color="#c6805dff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7521" transform="translate(446.1279,164.2803)">
                  <path
                    d="m 0,0 c -77.83,-77.829 -204.018,-77.829 -281.848,0 -77.829,77.83 -77.829,204.018 0,281.848 77.83,77.829 204.018,77.829 281.848,0 C 77.829,204.018 77.829,77.83 0,0"
                    id="path7523"
                    fill="#bdbfc3"
                    fill-opacity="1"
                    data-original-color="#80b4fbff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7525" transform="translate(446.127,446.1279)">
                  <path
                    d="M 0,0 C -42.732,42.732 -100.043,61.996 -155.923,57.804 -110.027,54.36 -65.096,35.097 -30,0 c 77.83,-77.83 77.83,-204.018 0,-281.847 -35.096,-35.097 -80.027,-54.361 -125.923,-57.804 55.88,-4.192 113.191,15.071 155.923,57.804 C 77.83,-204.018 77.83,-77.83 0,0"
                    id="path7527"
                    fill="#959595"
                    fill-opacity="1"
                    data-original-color="#61a2f9ff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7529" transform="translate(164.2803,305.2041)">
                  <path
                    d="M 0,0 C 0,77.706 63.218,140.924 140.924,140.924 218.63,140.924 281.848,77.706 281.848,0 281.848,-77.706 218.63,-140.924 140.924,-140.924 63.218,-140.924 0,-77.706 0,0"
                    id="path7531"
                    fill="#f9f7f8"
                    fill-opacity="1"
                    data-original-color="#f9f7f8ff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7533" transform="translate(305.2041,446.1279)">
                  <path
                    d="m 0,0 c -5.066,0 -10.069,-0.275 -15,-0.8 70.68,-7.512 125.923,-67.484 125.923,-140.124 0,-72.639 -55.243,-132.611 -125.923,-140.124 4.931,-0.524 9.934,-0.799 15,-0.799 77.706,0 140.923,63.217 140.923,140.923 C 140.923,-63.218 77.706,0 0,0"
                    id="path7535"
                    fill="#efedef"
                    fill-opacity="1"
                    data-original-color="#efedefff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7537" transform="translate(252.1201,358.2881)">
                  <path
                    d="M 0,0 V 0 C 11.688,11.687 30.636,11.687 42.322,0 L 74.256,-31.935 31.935,-74.256 0,-42.322 C -11.687,-30.635 -11.687,-11.687 0,0"
                    id="path7539"
                    fill="#ff5f7a"
                    fill-opacity="1"
                    data-original-color="#ff5f7aff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7541" transform="translate(294.4424,358.2881)">
                  <path
                    d="m 0,0 c -11.687,11.687 -30.636,11.687 -42.322,0 -2.642,-2.642 -4.68,-5.656 -6.128,-8.872 11.012,4.956 24.404,2.917 33.45,-6.128 l 31.935,-31.935 15,15 z"
                    id="path7543"
                    fill="#fb4455"
                    fill-opacity="1"
                    data-original-color="#fb4455ff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7545" transform="translate(326.376,326.3535)">
                  <path
                    d="m 0,0 -42.321,-42.321 31.856,-31.858 c 11.73,-11.729 30.713,-11.763 42.4,-0.077 11.686,11.688 11.652,30.67 -0.078,42.4 z"
                    id="path7547"
                    fill="#b4b4b2"
                    fill-opacity="1"
                    data-original-color="#ffe077ff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7549" transform="translate(358.2334,294.4971)">
                  <path
                    d="m 0,0 -31.856,31.856 -15,-15 L -30,0 c 11.729,-11.729 11.765,-30.712 0.077,-42.399 -1.879,-1.879 -3.947,-3.45 -6.142,-4.723 11.472,-6.623 26.361,-5.059 36.142,4.723 C 11.765,-30.712 11.729,-11.729 0,0"
                    id="path7551"
                    fill="#868583"
                    fill-opacity="1"
                    data-original-color="#ffd05bff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7553" transform="translate(208.9434,403.7783)">
                  <path
                    d="m 0,0 c 0,-47.343 -38.379,-85.722 -85.722,-85.722 -47.342,0 -85.721,38.379 -85.721,85.722 0,47.343 38.379,85.722 85.721,85.722 C -38.379,85.722 0,47.343 0,0"
                    id="path7555"
                    fill="#ff5f7a"
                    fill-opacity="1"
                    data-original-color="#ff5f7aff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7557" transform="translate(123.2217,489.5)">
                  <path
                    d="m 0,0 c -5.12,0 -10.127,-0.475 -15,-1.335 40.187,-7.097 70.722,-42.164 70.722,-84.387 0,-42.222 -30.535,-77.29 -70.722,-84.385 4.873,-0.862 9.88,-1.336 15,-1.336 47.343,0 85.722,38.379 85.722,85.721 C 85.722,-38.379 47.343,0 0,0"
                    id="path7559"
                    fill="#fb4455"
                    fill-opacity="1"
                    data-original-color="#fb4455ff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7561" transform="translate(86.1084,51.0557)">
                  <path
                    d="m 0,0 c 9.679,9.68 9.679,25.373 0,35.053 -9.68,9.678 -25.374,9.678 -35.053,0 C -44.732,25.373 -44.732,9.68 -35.053,0 -25.374,-9.68 -9.68,-9.68 0,0"
                    id="path7563"
                    fill="#ffffff"
                    fill-opacity="1"
                    data-original-color="#ffffffff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7565" transform="translate(204.0801,133.4199)">
                  <path
                    d="m 0,0 -83.52,-102.47 c -23.84,-29.24 -67.73,-31.469 -94.4,-4.79 -26.68,26.67 -24.45,70.56 4.79,94.401 L -70.66,70.66 C -62.29,56.45 -52,43.061 -39.8,30.86 -27.6,18.66 -14.21,8.37 0,0 Z"
                    id="path7567"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7569" transform="translate(316.4189,504.1865)">
                  <path
                    d="M 0,0 C -46.286,2.593 -93.303,-10.88 -131.979,-40.417"
                    id="path7571"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7573" transform="translate(106.4297,319.71)">
                  <path
                    d="m 0,0 c -2.88,-39.76 6.11,-80.229 26.99,-115.63 8.37,-14.21 18.66,-27.599 30.861,-39.8 12.2,-12.2 25.589,-22.49 39.799,-30.86 76.411,-45.06 176.42,-34.77 242.05,30.86 77.83,77.83 77.83,204.02 0,281.85 -27.148,27.148 -60.18,44.826 -94.993,53.035"
                    id="path7575"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7577" transform="translate(305.2002,164.2803)">
                  <path
                    d="M 0,0 C -4.133,0 -8.225,0.179 -12.268,0.529 -84.246,6.766 -140.92,67.353 -140.92,140.92 c 0,8.359 0.73,16.559 2.13,24.53"
                    id="path7579"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7581" transform="translate(208.8398,407.9404)">
                  <path
                    d="m 0,0 c 25.22,23.67 59.13,38.189 96.36,38.189 77.71,0 140.93,-63.219 140.93,-140.929 0,-65.662 -45.148,-120.985 -106.037,-136.549"
                    id="path7583"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7585" transform="translate(252.1201,358.2881)">
                  <path
                    d="M 0,0 V 0 C 11.688,11.687 30.636,11.687 42.322,0 L 74.256,-31.935 31.935,-74.256 0,-42.322 C -11.687,-30.635 -11.687,-11.687 0,0 Z"
                    id="path7587"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7589" transform="translate(326.376,326.3535)">
                  <path
                    d="m 0,0 -42.321,-42.321 31.856,-31.858 c 11.73,-11.729 30.713,-11.763 42.4,-0.077 11.686,11.688 11.652,30.67 -0.078,42.4 z"
                    id="path7591"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7593" transform="translate(208.9434,403.7783)">
                  <path
                    d="m 0,0 c 0,-47.343 -38.379,-85.722 -85.722,-85.722 -47.342,0 -85.721,38.379 -85.721,85.722 0,47.343 38.379,85.722 85.721,85.722 C -38.379,85.722 0,47.343 0,0 Z"
                    id="path7595"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7597" transform="translate(120.7383,358.4492)">
                  <path
                    d="M 0,0 C 0,-4.142 3.358,-7.5 7.5,-7.5 11.643,-7.5 15,-4.142 15,0 15,4.143 11.643,7.5 7.5,7.5 3.358,7.5 0,4.143 0,0"
                    id="path7599"
                    fill="#000000"
                    fill-opacity="1"
                    data-original-color="#000000ff"
                    stroke="none"
                    stroke-opacity="2"
                  />
                </g>
                <g id="g7601" transform="translate(105.2627,427.2119)">
                  <path
                    d="M 0,0 C 0,1.088 0.075,2.157 0.222,3.205 1.802,14.529 11.636,23.21 23.45,22.972 35.401,22.73 45.301,13.159 45.921,1.223 c 0.686,-13.229 -9.851,-24.2 -22.945,-24.2 v -24.025"
                    id="path7603"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
                <g id="g7605" transform="translate(86.1084,51.0557)">
                  <path
                    d="m 0,0 c 9.679,9.68 9.679,25.373 0,35.053 -9.68,9.678 -25.374,9.678 -35.053,0 C -44.732,25.373 -44.732,9.68 -35.053,0 -25.374,-9.68 -9.68,-9.68 0,0 Z"
                    id="path7607"
                    fill="none"
                    fill-opacity="1"
                    stroke="#000000"
                    stroke-opacity="2"
                    data-original-stroke-color="#000000ff"
                    stroke-width="10"
                    data-original-stroke-width="15"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg> */}
    </SvgIcon>
  );
}
